import React, { useState, useEffect } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from 'reactstrap';

const SessionWarningModal = ({ 
  isOpen, 
  onContinue, 
  onLogout, 
  timeRemaining 
}) => {
  const [countdown, setCountdown] = useState(timeRemaining);

  useEffect(() => {
    if (isOpen && timeRemaining > 0) {
      setCountdown(timeRemaining);
      
      const timer = setInterval(() => {
        setCountdown(prev => {
          if (prev <= 1) {
            clearInterval(timer);
            // Auto logout when countdown reaches 0
            onLogout();
            return 0;
          }
          return prev - 1;
        });
      }, 1000);

      return () => clearInterval(timer);
    }
  }, [isOpen, timeRemaining, onLogout]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
  };

  return (
    <Modal 
      isOpen={isOpen} 
      backdrop="static" 
      keyboard={false}
      centered
      size="md"
    >
      <ModalHeader className="bg-warning text-dark">
        <i className="fas fa-exclamation-triangle me-2"></i>
        Session Expiring Soon
      </ModalHeader>
      <ModalBody>
        <Alert color="warning" className="mb-3">
          <h6 className="alert-heading">Your session is about to expire!</h6>
          <p className="mb-0">
            For your security, you will be automatically logged out in:
          </p>
        </Alert>
        
        <div className="text-center my-4">
          <div className="display-4 text-danger font-weight-bold">
            {formatTime(countdown)}
          </div>
          <small className="text-muted">minutes:seconds remaining</small>
        </div>

        <div className="text-center">
          <p className="mb-0">
            Would you like to continue your session or log out now?
          </p>
        </div>
      </ModalBody>
      <ModalFooter>
        <Button 
          color="secondary" 
          onClick={onLogout}
          className="me-2"
        >
          <i className="fas fa-sign-out-alt me-1"></i>
          Logout Now
        </Button>
        <Button 
          color="primary" 
          onClick={onContinue}
        >
          <i className="fas fa-clock me-1"></i>
          Continue Session
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default SessionWarningModal;
